import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FormsBuilderPolishedComponent } from './forms-builder-polished.component';
import { FormsBuilderPolishedItemComponent } from './forms-builder-polished-item/forms-builder-polished-item.component';
import { FormsGlobals } from '../../../models/forms/forms.enum';
import { FormsBuilderPolishedConfirmComponent } from './forms-builder-polished-confirm/forms-builder-polished-confirm.component';
import { FormsBuilderPolishedPreviewComponent } from './forms-builder-polished-preview/forms-builder-polished-preview.component';
import { FormFinderComponent } from './form-finder/form-finder.component';
import { ParagraphBuilderComponent } from './paragraph-builder/paragraph-builder.component';
import { PrintPreviewComponent } from './print-preview/print-preview.component';
import { FormsBuilderTutorialComponent } from './tutorial/forms-builder-tutorial.component';

import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSliderModule } from '@angular/material/slider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsFormModule } from '../forms-form/forms-form.module';
import { FormsItemModule } from '../forms-item/forms-item.module';
import { FormsBuilderPolishedFormCreationComponent } from './forms-builder-polished-form-creation/forms-builder-polished-form-creation.component';
import {TdoControlsModule} from '../../../tdo-controls/tdo-controls.module';
import { MatIconModule } from '@angular/material/icon';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { FormsBuilderAiStudioDialogComponent } from './forms-builder-ai-studio-dialog/forms-builder-ai-studio-dialog.component';
import { FormsBuilderAiImportReviewDialogComponent } from './forms-builder-ai-import-review-dialog/forms-builder-ai-import-review-dialog.component';



@NgModule({
  declarations: [
    FormsBuilderPolishedComponent,
    FormsBuilderPolishedItemComponent,
    FormsBuilderPolishedConfirmComponent,
    FormsBuilderPolishedPreviewComponent,
    FormsBuilderPolishedFormCreationComponent,
    FormFinderComponent,
    ParagraphBuilderComponent,
    FormsBuilderAiStudioDialogComponent,
    FormsBuilderAiImportReviewDialogComponent,
    PrintPreviewComponent,
    FormsBuilderTutorialComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        FormsFormModule,
        FormsItemModule,

        MatRadioModule,
        MatCheckboxModule,
        MatSliderModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatDatepickerModule,
        MatDividerModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatDialogModule,
        MatSnackBarModule,
        MatExpansionModule,
        MatTabsModule,
        DragDropModule,
        TdoControlsModule,
        MatIconModule,
        LucideIconsModule,
    ],
  exports: [
    FormsBuilderPolishedComponent,
    FormFinderComponent,
    ParagraphBuilderComponent
  ],
  providers: [
    FormsGlobals
  ]
})
export class FormsBuilderPolishedModule { }



